import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import moment from 'moment';
import { get } from 'lodash'
import { VERSION } from './../../constants/version';

import Radiobutton from './../shared/Radiobutton';
import Button from './../shared/Button';

import IntroModal from './IntroModal';
import FinishModal from './FinishModal';
import TimeoutModal from './TimeoutModal';
// import baseStyles from './../../styles/base.styl';
import baseStyles from 'custom/base.styl';

import { profileUpdateStages, profileFetch } from "../../store/profile/actions";
import questions from './questions.json';
import { setValue, getValue, clearValue } from '../../utils/keyStorage';

const STEP_KEY = 'atstp';
const DEAD_KEY = 'atddl';
const SCORE_KEY = 'atscr';
const TIME_LEFT = '00:20:00';
const TEST_SECONDS = 1200;
const IS_START = 'isstart';

class PageAcademicTest extends Component {
  constructor(props) {
    super(props);

    clearInterval(this.interval);

    let step = +getValue(STEP_KEY) || 0;

    if (step === 0 && !getValue(IS_START)) {
      clearValue(STEP_KEY);
      clearValue(DEAD_KEY);
      clearValue(SCORE_KEY);
    }

    let deadline = getValue(DEAD_KEY) || null;
    if (deadline) {
      const nowMoment = moment();
      const deadlineMoment = moment(deadline);
      const duration = moment.duration(deadlineMoment.diff(nowMoment));
      if (duration <= 0) {
        clearValue(STEP_KEY);
        clearValue(DEAD_KEY);
        clearValue(SCORE_KEY);
        clearValue(IS_START);
        step = 0;
        deadline = null;
      }
    }

    const score = +getValue(SCORE_KEY) || 0;
    this.state = {
      step,
      deadline,
      answerValue: null,
      // showStartModal: !step,
      showStartModal: !getValue(IS_START),
      showTimeoutModal: false,
      showFinishModal: false,
      firstSelect: false,
      score,
      timeLeft: TIME_LEFT,
      isChecked: false,
    };

    this.onStart = this.onStart.bind(this);
    this.onContinue = this.onContinue.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.handleInterval = this.handleInterval.bind(this);
    this.onCheckHandle = this.onCheckHandle.bind(this);
    this.onContinue = this.onContinue.bind(this);
    this.onStartEssay = this.onStartEssay.bind(this);
  }

  componentDidMount() {
    const { step } = this.state;
    // const { loadProfile } = this.props

    // loadProfile();

    // if (step) {
    if (step || getValue(IS_START)) {
      this.interval = setInterval(this.handleInterval, 1000);
    }
  }

  onCheckHandle() {
    this.setState({ isChecked: true });
  }

  handleInterval() {
    const { deadline } = this.state;

    if (deadline) {
      const nowMoment = moment();
      const deadlineMoment = moment(deadline);
      const duration = moment.duration(deadlineMoment.diff(nowMoment));
      const timeLeft = duration.format('00:mm:ss');
      if (duration >= 0) {
        this.setState({ timeLeft });
        return;
      }
    }

    clearInterval(this.interval);
    this.setState({
      timeLeft: TIME_LEFT,
      showTimeoutModal: true,
      showFinishModal: false,
    });
  }

  onStart() {
    const step = 0;
    const score = 0;
    const deadline = moment();
    deadline.add(TEST_SECONDS, 's');
    setValue(DEAD_KEY, deadline.toISOString());
    setValue(STEP_KEY, step);
    setValue(SCORE_KEY, score);
    setValue(IS_START, true);
    this.setState({
      showStartModal: false,
      showTimeoutModal: false,
      showFinishModal: false,
      step,
      deadline: deadline.toISOString(),
      score,
    }, () => {
      this.handleInterval();
      this.interval = setInterval(this.handleInterval, 1000);
    });
  }

  onContinue() {
    const deadline = moment();
    deadline.add(TEST_SECONDS, 's');
    setValue(DEAD_KEY, deadline.toISOString());
    this.setState({
      showStartModal: false,
      showTimeoutModal: false,
      showFinishModal: false,
      deadline: deadline.toISOString(),
    }, () => {
      this.handleInterval();
      this.interval = setInterval(this.handleInterval, 1000);
    });
  }

  onNextClick() {
    const { step, answerValue, score } = this.state;
    const { nextStage, version } = this.props;

    const question = questions[step];
    if (question.correct !== answerValue) {
      return;
    }

    if (step >= questions.length - 1) {
      if (version !== VERSION.v0 || version !== VERSION.v1) {
        this.setState({ showFinishModal: true })
      }
      else {
        clearValue(DEAD_KEY);
        clearValue(STEP_KEY);
        clearValue(SCORE_KEY);
        nextStage(score);
      }
      return;
    }

    this.setState(state => {
      const step = state.step + 1;
      setValue(STEP_KEY, step);
      return {
        step,
        answerValue: null,
        firstSelect: false,
      };
    });
  }

  onStartEssay() {
    const { score } = this.state;
    const { nextStage } = this.props;

    clearValue(DEAD_KEY);
    clearValue(STEP_KEY);
    clearValue(SCORE_KEY);
    nextStage(score);
  }


  onRadioChange(event) {
    const { firstSelect, step } = this.state;
    const answerValue = +event.target.value;
    this.setState({ isChecked: false });

    if (firstSelect) {
      this.setState({ answerValue });
      return;
    }
    const question = questions[step];
    if (question.correct === answerValue) {
      this.setState(state => {
        const score = +state.score + 1;
        setValue(SCORE_KEY, score);
        return {
          answerValue,
          firstSelect: true,
          score,
        };
      });
      return;
    }

    this.setState(state => ({
      answerValue,
      firstSelect: true,
    }));
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  renderButton() {
    const { step, answerValue, isChecked } = this.state;
    const question = questions[step];

    if (question.correct === answerValue && isChecked) {
      return (
        <Button onClick={this.onNextClick}>Next</Button>
      );
    }

    const isDisabledBtn = answerValue === null || (question.correct !== answerValue && isChecked);

    let text = 'Select answer';
    if (question.correct !== answerValue && isChecked && answerValue !== null) {
      text = 'Select correct answer';
    }

    if (answerValue !== null && !isChecked) {
      text = 'Check answer';
    }

    return (
      <Button disabled={isDisabledBtn} onClick={this.onCheckHandle}>{text}</Button>
    );
  }

  renderTestItem() {
    const { step, answerValue, isChecked } = this.state;
    const question = questions[step];
    return (
      <div>
        <div className={baseStyles.academic_header}>
          <div className={baseStyles.test_header}>{step + 1} / {questions.length}</div>
          <h3 className={baseStyles.test_title}>{step + 1}. {question.text}</h3>
        </div>

        <div className={baseStyles.test_body}>
          {question.answers.map((answer, idx) => (
            <div className={classnames(baseStyles.radio_wrap, { [baseStyles.active]: answerValue === idx && isChecked })} key={idx}>
              <Radiobutton
                name="answerValue"
                onChange={this.onRadioChange}
                value={idx}
                checked={answerValue === idx}
                customIcon={question.correct === idx && answerValue === idx && isChecked}
              >
                <p className={classnames({ [baseStyles.text_correct]: question.correct === idx, [baseStyles.text_incorrect]: question.correct !== idx })}>{answer.text}</p>
              </Radiobutton>

              <p className={classnames(
                baseStyles.academic_comment, {
                [baseStyles.academic_comment_success]: question.correct === idx,
                [baseStyles.academic_comment_danger]: question.correct !== idx,
              })}>
                {answer.comment}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderTimer() {
    const { timeLeft } = this.state;
    return (
      <div>
        <span>Time left: <strong>{timeLeft}</strong></span>
      </div>
    );
  }

  render() {
    const { showStartModal, showTimeoutModal, showFinishModal } = this.state;
    const { isUSA, version, subjectType } = this.props;

    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing, baseStyles.academic_testing)}>
        {this.renderTestItem()}

        <div className={baseStyles.test_footer}>
          {this.renderButton()}
          {this.renderTimer()}
        </div>
        {!!showFinishModal && <FinishModal version={version} onStartEssay={this.onStartEssay} isUSA={isUSA} subjectType={subjectType} />}
        {!!showStartModal && <IntroModal onStart={this.onStart} isUSA={isUSA} />}
        {!!showTimeoutModal && <TimeoutModal onContinue={this.onContinue} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const utmType = get(state.profile.data, 'user.profile.utm_type');
  const isUSA = utmType && utmType === 'usa';
  const version = state.profile && state.profile.data && state.profile.data.user && state.profile.data.user.scenario_version;
  const profile = state.profile;
  const subjectType = get(profile.data, 'user.profile.subject_type');


  return {
    isUSA,
    version,
    subjectType,
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: score => dispatch(profileUpdateStages({ score })),
  loadProfile: () => dispatch(profileFetch()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageAcademicTest);



// WEBPACK FOOTER //
// ./src/components/AcademicTest/PageAcademicTest.js